export default {
	oemDataModal_celsius: "{value} °C",
	oemDataModal_cerebrumx_diagnostics_coolantTemperature: "Temperatura del refrigerante",
	oemDataModal_cerebrumx_diagnostics_engine: "Motor",
	oemDataModal_cerebrumx_diagnostics_engineHours: "Horas de motor",
	oemDataModal_cerebrumx_diagnostics_engineSpeed: "Régimen del motor",
	oemDataModal_cerebrumx_diagnostics_ignitionStatus: "Estado de ignición (código)",
	oemDataModal_cerebrumx_diagnostics_oilLife: "Vida del aceite",
	oemDataModal_cerebrumx_diagnostics_noTireData: "Este evento no trae datos de presión de llantas",
	oemDataModal_cerebrumx_diagnostics_placard: "Placa {value}",
	oemDataModal_cerebrumx_diagnostics_tireFL: "Presión llanta DI",
	oemDataModal_cerebrumx_diagnostics_tireFR: "Presión llanta DD",
	oemDataModal_cerebrumx_diagnostics_tireRL: "Presión llanta TI",
	oemDataModal_cerebrumx_diagnostics_tireRR: "Presión llanta TD",
	oemDataModal_cerebrumx_diagnostics_unit: "psi",
	oemDataModal_cerebrumx_diagnostics_wheels_fl: "DI",
	oemDataModal_cerebrumx_diagnostics_wheels_fr: "DD",
	oemDataModal_cerebrumx_diagnostics_wheels_rl: "TI",
	oemDataModal_cerebrumx_diagnostics_wheels_rr: "TD",
	oemDataModal_cerebrumx_emptyTab: "Este payload no trae nada para esta pestaña.",
	oemDataModal_cerebrumx_energy_absEvLevel: "Nivel EV absoluto",
	oemDataModal_cerebrumx_energy_absFuelLevel: "Combustible en tanque",
	oemDataModal_cerebrumx_energy_battery: "Batería",
	oemDataModal_cerebrumx_energy_batteryVoltage: "Batería del vehículo",
	oemDataModal_cerebrumx_energy_distanceToEmpty: "Autonomía",
	oemDataModal_cerebrumx_energy_electric: "Eléctrico",
	oemDataModal_cerebrumx_energy_evLevel: "Nivel EV",
	oemDataModal_cerebrumx_energy_fuel: "Combustible",
	oemDataModal_cerebrumx_energy_fuelLevel: "Nivel de combustible",
	oemDataModal_cerebrumx_energy_fuelTankCapacity: "Capacidad del tanque",
	oemDataModal_cerebrumx_energy_instantConsumption: "Consumo instantáneo",
	oemDataModal_cerebrumx_energy_totalFuelConsumed: "Combustible total consumido",
	oemDataModal_cerebrumx_energy_totalFuelEconomy: "Economía total de combustible",
	oemDataModal_cerebrumx_live_acceleration: "Aceleración",
	oemDataModal_cerebrumx_live_ambientTemperature: "Temperatura ambiente",
	oemDataModal_cerebrumx_live_eventType: "Tipo de evento",
	oemDataModal_cerebrumx_live_gear: "Marcha",
	oemDataModal_cerebrumx_live_lastReported: "Último reporte",
	oemDataModal_cerebrumx_live_lateralAcceleration: "Aceleración lateral",
	oemDataModal_cerebrumx_live_moving: "En movimiento",
	oemDataModal_cerebrumx_live_odometer: "Odómetro",
	oemDataModal_cerebrumx_live_speed: "Velocidad",
	oemDataModal_cerebrumx_live_speedGps: "Velocidad GPS",
	oemDataModal_cerebrumx_live_tripDistance: "Distancia del viaje",
	oemDataModal_cerebrumx_location_accelerationShort: "Acel.",
	oemDataModal_cerebrumx_location_altitude: "Altitud",
	oemDataModal_cerebrumx_location_coordinates: "Posición",
	oemDataModal_cerebrumx_location_gpsError: "Error GPS",
	oemDataModal_cerebrumx_location_gpsFix: "Fijación GPS",
	oemDataModal_cerebrumx_location_gpsInvalid: "Inválida",
	oemDataModal_cerebrumx_location_gpsValid: "Válida",
	oemDataModal_cerebrumx_location_heading: "Rumbo",
	oemDataModal_cerebrumx_location_lateralShort: "Lateral",
	oemDataModal_cerebrumx_location_samples: "Muestras de telemetría",
	oemDataModal_cerebrumx_location_showing: "Mostrando las {shown} muestras más recientes de {total}",
	oemDataModal_cerebrumx_location_speed: "Velocidad",
	oemDataModal_cerebrumx_location_time: "Hora",
	oemDataModal_cerebrumx_name: "CerebrumX",
	oemDataModal_cerebrumx_tabs_diagnostics: "Diagnóstico",
	oemDataModal_cerebrumx_tabs_energy: "Energía",
	oemDataModal_cerebrumx_tabs_live: "En vivo",
	oemDataModal_cerebrumx_tabs_location: "Ubicación",
	oemDataModal_cerebrumx_tabs_vehicle: "Vehículo",
	oemDataModal_cerebrumx_unreadable: "Este payload no tiene la forma JSON de CerebrumX.",
	oemDataModal_cerebrumx_vehicle_make: "Marca",
	oemDataModal_cerebrumx_vehicle_message: "Mensaje",
	oemDataModal_cerebrumx_vehicle_messageId: "ID de mensaje",
	oemDataModal_cerebrumx_vehicle_model: "Modelo",
	oemDataModal_cerebrumx_vehicle_oem: "OEM",
	oemDataModal_cerebrumx_vehicle_sentAt: "Enviado",
	oemDataModal_cerebrumx_vehicle_trim: "Versión",
	oemDataModal_cerebrumx_vehicle_tripId: "ID de viaje",
	oemDataModal_cerebrumx_vehicle_vin: "VIN",
	oemDataModal_cerebrumx_vehicle_year: "Año",
	oemDataModal_copied: "Copiado",
	oemDataModal_copy: "Copiar JSON",
	oemDataModal_degrees: "{value}°",
	oemDataModal_empty: "No se capturaron datos OEM crudos para el evento {eventId}.",
	oemDataModal_error: "No se pudieron cargar los datos OEM.",
	oemDataModal_fahrenheit: "{value} °F",
	oemDataModal_feet: "{value} ft",
	oemDataModal_gallons: "{value} gal",
	oemDataModal_hours: "{value} h",
	oemDataModal_km: "{value} km",
	oemDataModal_kph: "{value} km/h",
	oemDataModal_l100km: "{value} L/100 km",
	oemDataModal_liters: "{value} L",
	oemDataModal_loading: "Cargando datos OEM…",
	oemDataModal_measure: "{value} {unit}",
	oemDataModal_meta_eventId: "ID de evento",
	oemDataModal_meta_eventName: "Evento",
	oemDataModal_meta_manufacturer: "Fabricante",
	oemDataModal_meta_unitTime: "Hora de la unidad",
	oemDataModal_meters: "{value} m",
	oemDataModal_miles: "{value} mi",
	oemDataModal_mpg: "{value} mpg",
	oemDataModal_mph: "{value} mph",
	oemDataModal_no: "No",
	oemDataModal_noEvent: "Esta unidad aún no ha reportado un evento.",
	oemDataModal_noEventId: "Esta lectura no trae un ID de evento, así que sus datos OEM crudos no se pueden consultar.",
	oemDataModal_notAvailable: "N/D",
	oemDataModal_open: "Datos OEM",
	oemDataModal_openFor: "Ver datos OEM de {name}",
	oemDataModal_percent: "{value} %",
	oemDataModal_retry: "Reintentar",
	oemDataModal_tabs_json: "JSON crudo",
	oemDataModal_title: "Datos OEM",
	oemDataModal_yes: "Sí",
};
